import { render } from "./TelegramMessengerSettings.vue?vue&type=template&id=40415a8f"
import script from "./TelegramMessengerSettings.vue?vue&type=script&lang=js"
export * from "./TelegramMessengerSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__